import { queryChatbotList, queryCareChatbot } from '../services'
// import { stringify } from 'qs'

export default {
  namespaced: true,

  state: {
    name: 'chatbotList',
    chatbotList: [], // 有聊天记录的机器人，从storage中取
    allChatbot: [], // 所有的机器人
    subscribeChatbot: [] // 关注收藏的机器人
  },
  mutations: {
    minusPrice (state, params) {
      state.name = params
      // this.$store.commit('minusPrice', 2)
    },
    setChatbotList (state, params) {
      state.chatbotList = params
    },
    setAllChatbot (state, list) {
      state.allChatbot = list
    },
    setCareList (state, list) {
      state.subscribeChatbot = list || []
      const globalAllChatbot = state.allChatbot || []
      const newGlobal = globalAllChatbot.map(item => {
        const { maapCode } = item
        const existItem = list.find(chatbot => chatbot.maapCode === maapCode)
        if (existItem && existItem.careChatbotCode) {
          return { ...item, careChatbotCode: existItem.careChatbotCode }
        } else {
          return { ...item, careChatbotCode: null }
        }
      })
      state.allChatbot = newGlobal
    }
  },
  actions: {
    count ({ dispatch, commit, state }, params) {
      commit('minusPrice', 'chatbotList--2')
    },

    queryList ({ dispatch, commit, state }, { mobileNo }) {
      queryChatbotList(mobileNo).then(response => {
        console.log('queryChatbotList', response)
        if (response && response.data) {
          const list = response.data.map(chatbot => {
            return {
              maapServiceNo: chatbot.maapServiceNo,
              name: chatbot.name,
              channelCode: chatbot.channelCode,
              logo: chatbot.logo,
              maapCode: chatbot.maapCode,
              apiUrl: chatbot.apiUrl,
              websocketUrl: chatbot.websocketUrl
              // hasUnReadMessage: false, // 是否有未读消息
              // latestMessage: '', // '你好', // 最新一条消息
              // latestTime: null // new Date().getTime() // null, // 最近聊天时间
            }
          }) || []
          commit('setAllChatbot', list)
          dispatch({type: 'queryCareList', mobileNo})
        } else {
          console.log('查询机器人列表失败！')
          alert('查询机器人列表失败！')
        }
      })
    },

    queryCareList ({ dispatch, commit, state }, { mobileNo }) {
      queryCareChatbot(mobileNo).then(response => {
        console.log('关注列表', response)
        if (response && response.data) {
          const list = response.data || []
          commit('setCareList', list)
        } else {
          console.log('查询关注列表失败！')
          alert('查询我的关注失败！')
        }
      })
    },


  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/chatbotList/model.js